module.exports = __webpack_public_path__ + "img/2ab7b812dd9447818e0bbfa2ea0f321f.d4901892.jpg";